/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

/**
 * Three-tab counter card values rendered above the recipient list.
 */
export interface PreviewBucketCounts {
  /** @minimum 0 */
  no_issue: number;
  /** @minimum 0 */
  warning: number;
  /** @minimum 0 */
  fix: number;
}
